<template>
  <div>
    <el-form
      ref="batchQualityObjForm"
      :model="batchQualityObj"
      label-width="80px"
    >
      <el-row>
        <el-col v-if="!Permit.isFreeEdition() && showSelectShopDF()" :span="12">
          <el-form-item
            :label="$t('order.receiveShopName')"
            label-width="60px"
            required
          >
            <el-select
              size="small"
              v-model="batchQualityObj.shopId"
              filterable
              clearable
            >
              <el-option
                v-for="shop in shopsInv"
                :key="shop.id"
                :label="shop.name"
                :value="shop.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <vxe-table
        :data="items"
        class="recordsTable"
        size="mini"
        highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="images"
          :title="$t('product.images')"
          width="85"
        >
          <template v-slot="{ row }">
            <thumbnail :images="row.images"></thumbnail>
          </template>
        </vxe-table-column>

        <vxe-table-column
          field="serialNo"
          :title="$t('text.serialNo')"
          min-width="120"
        >
          <template v-slot="{ row }">
            {{ row.serialNo }}
            <div class="font10">{{ $t("receiveTypes." + row.type) }}</div>
          </template>
        </vxe-table-column>

        <vxe-table-column
          field="productNo"
          :title="$t('product.productNo')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.productNo }}
            <div class="font10">{{ row.color }} {{ row.size }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="quantity"
          :title="$t('text.quantity')"
          min-width="50"
        />

        <vxe-table-column :title="$t('receive.receiver')" min-width="100">
          <template v-slot="{ row }">
            {{ row.receiver }}
            <div class="font10">{{ row.receiveAt }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="qualityQuantity"
          :title="$t('receive.qualityQuantity')"
          min-width="80"
        >
          <template v-slot="{ row }">
            {{ row.qualityQuantity }}
            <div v-if="row.storageShopName != null" class="font10">
              {{ $t("order.receiveShopName") }}:{{ row.storageShopName }}
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="reworkQuantity"
          :title="$t('receive.reworkQuantity')"
          min-width="80"
        />

        <vxe-table-column
          :title="$t('receive.pengingQualityQuantity')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.qualityQty }}
          </template>
        </vxe-table-column>

        <vxe-table-column :title="$t('receive.storageQuantity')" min-width="80">
          <template v-slot="{ row }">
            {{ row.storageQuantity }}
            <div v-if="row.storageShopName != null" class="font10">
              {{ $t("order.receiveShopName") }}:{{ row.storageShopName }}
            </div>
          </template>
        </vxe-table-column>

        <vxe-table-column field="action" :title="$t('text.action')" width="50">
          <template v-slot="{ row, rowIndex }">
            <el-button type="text" @click="remove(row, rowIndex)" size="mini">
              {{ $t("text.remove") }}
            </el-button>
          </template>
        </vxe-table-column>
      </vxe-table>
    </el-form>

    <div class="right pd20">
      <span class="mgr10">
        {{ $t("text.total") }}：{{ countCurrnetTotal() }}
      </span>
      <el-button
        size="small"
        type="primary"
        :loading="submitDoing"
        @click="submit"
      >
        {{ $t("text.submit") }}
      </el-button>
      <el-button size="small" type="default" @click="close">
        {{ $t("text.close") }}
      </el-button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { page } from "@/utils/mixins.js";
import Util from "@/utils";
import Cookies from "@/utils/cookies";
import Thumbnail from "@/components/Thumbnail";
import Shop from "@/api/shop.js";
import Quality from "@/api/quality.js";

export default {
  props: {
    items: Array,
  },
  mixins: [page],
  components: { Thumbnail },
  data() {
    return {
      shops: [],
      shopsInv: [],
      batchQualityObj: {
        shopId: null,
        remark: null,
      },
      submitDoing: false,
    };
  },
  created() {
    const self = this;
    for (const item of self.items) {
      const maxQualityQty =
        item.quantity - item.qualityQuantity - item.reworkQuantity;
      Vue.set(item, "qualityQty", maxQualityQty);
      Vue.set(item, "_maxQualityQty", maxQualityQty);
    }
    self.countCurrnetTotal();
    self.showSelectShopDF();
    Shop.findByTenantId().then(function (res) {
      if (res.status === 200) {
        self.shops = res.data;
        self.shopsInv = res.data.filter((s) => s.isInventory === true);
        if (!self.Permit.isFreeEdition()) {
          if (self.shopsInv.length == 1) {
            self.batchQualityObj.shopId = self.shopsInv[0].id;
          }
          if (
            Cookies.getReceiveShopId() != undefined &&
            Cookies.getReceiveShopId() != null &&
            self.shopsInv.find(
              (s) => (s.id == Number(Cookies.getReceiveShopId())) != null
            )
          ) {
            self.batchQualityObj.shopId = Number(Cookies.getReceiveShopId());
          }
        }
      } else {
        self.sysError();
      }
    });
  },

  methods: {
    showSelectShopDF() {
      const storageShopIds = this.items.map((i) => i.storageShopId);
      if (storageShopIds.includes(null)) {
        return true;
      }
      return false;
    },

    countCurrnetTotal(records) {
      let total = 0;
      if (this.items.length === 0) {
        return 0;
      }
      this.items.map((i) => {
        total += Number(i.qualityQty);
      });
      return total;
    },
    remove(row, rowIndex) {
      this.items.splice(rowIndex, 1);
      this.countCurrnetTotal();
      this.showSelectShopDF();
    },
    submit() {
      const self = this;
      if (self.items.length === 0) {
        self.$message.error(self.$t("prompt.atLeastOneData"));
        return;
      }
      // 免费版本
      if (self.Permit.isFreeEdition()) {
        self.batchQualityObj.shopId = self.shops[0].id;
        self.batchQualityObj.receiveShopName = self.shops[0].name;
      }
      //　收费版本
      if (!self.Permit.isFreeEdition() && self.showSelectShopDF()) {
        if (
          self.batchQualityObj.shopId == null ||
          self.batchQualityObj.shopId == ""
        ) {
          self.$message({
            message: self.$t("rules.select", [self.$t("menu.warehouses")]),
            type: "warning",
          });
          return;
        }
        self.batchQualityObj.receiveShopName = self.shops.find(
          (s) => s.id == self.batchQualityObj.shopId
        ).name;
      }

      const data = self.items.map((i) => {
        return {
          id: i.id,
          shopId:
            i.storageShopId != null
              ? i.storageShopId
              : self.batchQualityObj.shopId,
        };
      });
      self.submitDoing = true;
      Quality.batchQuality(data).then(function (res) {
        self.submitDoing = false;
        if (res.status == 200) {
          self.sysResults(res.data, self.$t("prompt.qualitySuccess"));
          self.$emit("updateData");
          self.$eventHub.$emit("qualityBatchQuality");
          Cookies.setReceiveShopId(self.batchQualityObj.shopId);
        } else {
          self.sysError();
        }
      });
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>
